import type { StaticRouteConfigs } from "./static-route.type";

export const STATIC_ROUTES_CONFIGS: StaticRouteConfigs = {
  dashboard: {
    route: "/org/:context",
  },
  my_space: {
    route: "/org/:context/my-space",
  },
  import: {
    route: "/admin/import",
  },
  preferences: {
    route: "/preferences",
  },
  login: {
    route: "/auth/login",
  },
  sso_error: {
    route: "/sso/error",
  },
  maintenance: {
    route: "/maintenance",
  },
};
